export default {
  selectSize: 'Seleziona la specifica completa',
  inventory: 'Inventario',
  num: 'Quantità',
  nimNumTips: "Quantità minima d'acquisto: {num}",
  addCart: 'Aggiungi al carrello',
  nowBuy: 'Acquista ora',
  remark: 'Lascia un messaggio',
  goShop: 'ENTRA NEL NEGOZIO',
  productTotalPrice: 'Il prezzo totale del prodotto',
  productDetail: 'Dettagli del prodotto',
  sizeParams: 'Parametri di specifica',
  shopNotes: "Note dell'agente d'acquisto",
  saleService: 'Servizio post-vendita',
  productInfo: 'Informazioni sul prodotto',
  buyTips:
    'Gli ordini pagati tra le 09:00 e le 18:00 (ora di Pechino) verranno elaborati entro 6 ore (eccetto la domenica).',
  buyer: 'Venditore',
  selfWarehouse: 'Magazzino designato Acbuy',
  warehouse: 'Magazzino designato Acbuy',
  yourAddress: 'Il tuo indirizzo',
  calcCountryFreight: 'Stima le spese di spedizione internazionali',
  holder: {
    remarkHolder:
      "Se hai altre esigenze, lascia un messaggio nelle note, l'agente ti aiuterà con la richiesta.",
  },
  supportPayment: 'Metodi di pagamento disponibili',
  disclaimer:
    "Tutti i prodotti disponibili per il servizio di agente d'acquisto mostrati su acbuy provengono da piattaforme di acquisto di terze parti e non sono venduti direttamente da acbuy. Pertanto, acbuy non si assume alcuna responsabilità legale per i problemi causati dalla violazione dei diritti di proprietà intellettuale e dalla violazione del diritto d'autore della merce.",
  readAgree: 'Ho letto e accettato quanto sopra',
  selectAgree: 'Clausola di esclusione di responsabilità non accettata',
  copyLink: 'Copia link',
  copySuccess: 'Copia riuscita',
  disclaimer1: 'Clausola di esclusione di responsabilità',
  editPrice: 'Modifica prezzo',
  editPriceTips:
    "Si prega di notare che c'è un problema con lo scambio di coupon. Si consiglia all'utente di modificare il prezzo di vendita dell'articolo al prezzo originale.",
  editPriceEnum: {
    0: 'Sconto sulla spedizione',
    1: 'Errore di prezzo sul sito web',
    2: 'Negoziato con il venditore',
    3: 'Altra ragione',
  },
  imgTranslation: 'Traduzione immagine',
  translationTips: "Clicca sull'immagine per tradurre il testo",
  originTranslation: 'Originale/Traduzione',
  qcImg: 'Foto QC',
  deleteShopCollect: 'Sei sicuro di voler eliminare la collezione di questo negozio?',
  inTransition: 'In transizione...',
  originLink: 'Link originale',
  singleProductData: 'Dati del singolo prodotto',
}
